export const formFieldStyle = {
  padding: ".5rem",
  boxSizing: "border-box"
};
export default formFieldStyle;
